// extracted by css-extract-rspack-plugin
export default {"menu":"menu-fci1QB","currentAnchor":"currentAnchor-Uv2hh6","action":"action-amPW7z"};